/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, mp */

_.namespace(`mp.marketing.trends.reports`, function(ns) {
  'use strict';

  var old_models = [
    mp.marketing.trends.utils.IPHONE_7,
    mp.marketing.trends.utils.IPHONE_7_PLUS,
    mp.marketing.trends.utils.OTHER_IPHONE,
  ];
  var release_models = [
    mp.marketing.trends.utils.IPHONE_8,
    mp.marketing.trends.utils.IPHONE_8_PLUS,
    mp.marketing.trends.utils.IPHONE_X,
  ];
  var IPhone8 = mp.marketing.trends.widgets.PhoneAdoption.extend({
    get_display_models() {
      return release_models.concat(old_models);
    },
    get_release_models() {
      return release_models;
    },
    get_visible_models() {
      return release_models.concat(old_models.slice(0, 2));
    },
    get_query_name() {
      return mp.marketing.trends.utils.IPHONE_QUERY;
    },
    getDownloadName() {
      return ns.IPhone8.nice_name;
    },
  });

  Object.assign(IPhone8, {
    slug: `iphone_8_X`,
    nice_name: `iPhone 8 and iPhone X adoption`,
    description: `How quickly will people start using the new iPhone 8 or iPhone X?`,
  });
  ns.IPhone8 = IPhone8;
});

}.call(window));